import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=55f1c6c3&scoped=true"
import script from "./DemoPage.vue?vue&type=script&lang=js"
export * from "./DemoPage.vue?vue&type=script&lang=js"
import style0 from "./DemoPage.vue?vue&type=style&index=0&id=55f1c6c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f1c6c3",
  null
  
)

export default component.exports